<template lang="pug">

  MDashboardWidget( title="Advertisers by identified ALP domain" )

    div(class="form-group row")

      div(class="col-sm-12")
        label Date range
        input( type="date" placeholder="End date" class="form-control" v-model="startDate" )
        input( type="date" placeholder="Start date" class="form-control" v-model="endDate" )
        MInput(
          type="select"
          label="Network"
          name="networkId"
          v-bind:options="networkOptions"
          v-on:change="onNetworkChange"
          v-bind:value="selectedNetworkId"
          class="mt-2"
        )

        MInput(
          type="select"
          filterable
          label="Advertiser"
          name="advertiserId"
          v-bind:options="advertiserOptions"
          @change="onAdvertiserChange"
          v-bind:disabled="! selectedNetworkId"
          :value="selectedAdvertiserId"
        )
          div( slot="description" )
            router-link( to="/cms/advertisers/create" target="_blank" )
              i( class="fa fa-external-link mr-2" )
              | Create advertiser

        div(class="col-sm-12 mt-3")
          button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="!selectedNetworkId || !selectedAdvertiserId || loading" v-on:click="generateCSV('publisher')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Publisher Report
          button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="advertiserNames.length === 0 || loading" v-on:click="generateCSV('debug')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Debug Report
          button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="advertiserNames.length === 0 || loading" v-on:click="generateCSV('debug-without-superseded')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Debug Without Superseded
          button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="advertiserNames.length === 0 || loading" v-on:click="generateCSV('full')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Multi Line Report
          button( class="btn btn-details btn-outline btn-info mr-2 mt-2" v-bind:disabled="advertiserNames.length === 0 || loading" v-on:click="generateCSV('newPublisher')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Playground Publisher Report
          button( class="btn btn-details btn-outline btn-info mr-2 mt-2" v-bind:disabled="advertiserNames.length === 0 || loading" v-on:click="generateCSV('newNetwork')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Playground Network Report


          p( class="text-danger m-0" v-if="errorMessage" ) {{ errorMessage }}

</template>

<style lang="scss" scoped></style>

<script>
import gql from "graphql-tag";
import Vue from "vue";
import * as dateFormat from "dateformat";
export default Vue.extend({
  data() {
    return {
      startDate: dateFormat(
        new Date(Date.now() - 69 * 24 * 60 * 60 * 1000),
        "yyyy-mm-dd"
      ),
      endDate: dateFormat(new Date(), "yyyy-mm-dd"),
      alps: "",
      loading: false,
      errorMessage: "",
      selectedNetworkId: null,
      selectedAdvertiserId: null,
      networkMany: [], // Initialize networkMany as an empty array
    };
  },
  computed: {
    networkOptions() {
      return this.getNetworkOptions();
    },
    advertiserOptions() {
      return this.getAdvertiserOptions();
    },
    advertiserNames() {
      return this.advertiserOptions
        .filter((a) => a.value !== null)
        .map((a) => a.label);
    },
  },
  apollo: {
    networkMany: {
      query: gql`
        query NetworkMany {
          networkMany(sort: { name: ASC }) {
            id
            name
            advertisers {
              id
              name
              domain
              advertiserId
            }
          }
        }
      `,
      result({ data }) {
        this.networkMany = data.networkMany;
      },
    },
  },
  methods: {
    myMethod() {
      console.log("do something");
    },

    async generateCSV(type) {
      this.loading = true;

      // ✅ Get the selected advertiser only
      const selectedAdvertiser = this.getAdvertiserOptions().find(
        (a) => a.value === this.selectedAdvertiserId
      );
      const advertiserNames = selectedAdvertiser
        ? [selectedAdvertiser.label]
        : [];

      try {
        const {
          data: { generateBatchCSV },
        } = await this.$apollo.query({
          query: gql`
            query GenerateBatchCSV(
              $startDate: DateTime!
              $endDate: DateTime!
              $advertiserNames: [String!]!
              $type: String!
            ) {
              generateBatchCSV(
                startDate: $startDate
                endDate: $endDate
                advertiserNames: $advertiserNames
                type: $type
              )
            }
          `,
          variables: {
            startDate: this.startDate,
            endDate: this.endDate,
            advertiserNames,
            type,
          },
        });

        if (!generateBatchCSV) {
          this.errorMessage = "No audits were found for the given search";
        } else {
          // ✅ Generate and trigger download
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.setAttribute("style", "display:none");
          const blob = new Blob([generateBatchCSV], { type: "octet/stream" });
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = `batches_${this.startDate}_${this.endDate}.csv`;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      } catch (error) {
        console.error("Error generating CSV:", error);
        this.errorMessage = "An error occurred while generating the CSV.";
      } finally {
        this.loading = false;
      }
    },

    getNetworkOptions() {
      if (!this.networkMany || this.networkMany.length === 0) {
        return [
          {
            value: null,
            label: "Please Select",
          },
        ];
      }
      return [
        {
          value: null,
          label: "Please Select",
        },
        ...this.networkMany.map((n) => ({
          value: n.id,
          label: n.name,
        })),
      ];
    },

    getAdvertiserOptions() {
      const selectedNetwork = this.networkMany?.find(
        (n) => n.id === this.selectedNetworkId
      );
      if (!selectedNetwork || !selectedNetwork.advertisers?.length) {
        return [
          {
            value: null,
            label: "No advertisers to display",
          },
        ];
      }
      return [
        {
          value: null,
          label: "Please Select",
        },
        ...selectedNetwork.advertisers.map((a) => ({
          value: a.id,
          label: a.name,
          description: `${a.domain} (${a.advertiserId})`,
          advertiserName: a.name, // Include advertiserName for additional use
        })),
      ];
    },

    onNetworkChange(e) {
      this.selectedNetworkId = e.target.value;
      this.selectedAdvertiserId = null;
    },

    onAdvertiserChange(e) {
      this.selectedAdvertiserId = e.target.value;
    },

    submit() {
      if (!this.selectedNetworkId) {
        this.errorMessage = "Please select a network.";
        return;
      }
      if (!this.selectedAdvertiserId) {
        this.errorMessage = "Please select an advertiser.";
        return;
      }
      if (!this.startDate || !this.endDate) {
        this.errorMessage = "Please select a valid date range.";
        return;
      }

      this.errorMessage = ""; // Clear any previous error messages
      console.log("Form submitted with the following data:");
      console.log({
        networkId: this.selectedNetworkId,
        advertiserId: this.selectedAdvertiserId,
        startDate: this.startDate,
        endDate: this.endDate,
      });

      // Additional logic for form submission can be added here
    },
  },
});
</script>
